import React, { FC } from 'react';
import RolesListPage from './role-list';
import { Routes, Route } from 'react-router-dom';
import RoleInformationPage from 'src/common/components/business/role-information-page';
import { useTranslation } from 'react-i18next';
import { Selector } from 'src/common/types';

const RolesIndex: FC = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path={`/*`} element={<RolesListPage />} />
      <Route
        path={`/new`}
        element={
          <RoleInformationPage
            header={t('NewRole')}
            maxSelector={Selector.Partners}
            mode="new"
            previousRoute="/roles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'roles', breadcrumbName: t('Roles') },
              { path: 'new', breadcrumbName: t('NewRole') },
            ]}
            canSelectOrganization
          />
        }
      />
      <Route
        path={`/update/:id`}
        element={
          <RoleInformationPage
            header={t('EditRole')}
            maxSelector={Selector.Partners}
            mode="edit"
            previousRoute="/roles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'roles', breadcrumbName: t('Roles') },
              { path: 'update', breadcrumbName: t('EditRole') },
            ]}
            canSelectOrganization
          />
        }
      />
    </Routes>
  );
};

export default RolesIndex;
